export const CONTACT_SUPPORT_KEY = 'sign_up_v2_page.disease_form.disease_search_v2.contact';
